import React, { useContext } from "react";
import { useNavigate } from "react-router-dom";
import "react-toastify/dist/ReactToastify.css";

//Style
import "./NavbarMobileBottom.css";

//Context
import { AuthContext } from "../../context/AuthContext";
import { authTypes } from "../../types/authTypes";

const NavbarMobileBottom = () => {
  const isFromWhatsapp = localStorage.getItem("is_from_whatsapp");

  const { dispatch } = useContext(AuthContext);

  const navigate = useNavigate();

  const handleLogout = () => {
    dispatch({ type: authTypes.logout });
    localStorage.removeItem("token");
    localStorage.removeItem("adminPreview");
    localStorage.removeItem("adminToken");
    localStorage.removeItem("userProfile");
    localStorage.removeItem("temp_doc");
    localStorage.removeItem("_grecaptcha");
  };

  return (
    <>
      <nav className="navbar-mobile-bottom-container">
        <div className="nb-menus-container">
          <div
            className="menu-container"
            onClick={() => navigate("/admin/metodos-de-pago")}
            style={{ opacity: isFromWhatsapp ? 0 : 1 }}
          >
            <img
              src="https://pagina-crediseguro.s3.amazonaws.com/portal-crediseguro/assets/icons/payment-methods-icon.webp"
              alt=""
              className="menu-icon"
            />
            <h1>Metodos de Pago</h1>
          </div>
          <div
            className="menu-container line"
            onClick={() => navigate("/admin/perfil")}
            style={{ opacity: isFromWhatsapp ? 0 : 1 }}
          >
            <img
              src="https://pagina-crediseguro.s3.amazonaws.com/portal-crediseguro/assets/icons/profile-icon.webp"
              alt=""
              className="menu-icon"
            />
            <h1>Perfil</h1>
          </div>
          <div
            title="Cerrar sesión"
            className="menu-container line"
            onClick={handleLogout}
            style={{ opacity: isFromWhatsapp ? 0 : 1 }}
          >
            <h1>Cerrar Sesión</h1>
            <img
              src="https://pagina-crediseguro.s3.amazonaws.com/portal-crediseguro/assets/icons/logout-icon.webp"
              alt=""
              className="menu-icon"
            />
          </div>
        </div>
      </nav>
    </>
  );
};

export default NavbarMobileBottom;
